import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const setChoice = async <T extends Action<ACTION_TYPE.SET_CHOICE>>({ uniqueId, choice }: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload: {
        uniqueId,
        choice
      },
      type: ACTION_TYPE.SET_CHOICE
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    const { choice: choiceSet } = body.data

    return {
      choice: choiceSet
    }
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.SET_CHOICE)
    throw err
  }
}
